// Single source of truth for marketing pricing surfaces.
// EUR amounts are derived from `src/config/pricing.ts` (the canonical cents store)
// so display anchors and the `plans` table can never drift.
import { PRICING, eurMajor } from "@/config/pricing";

export interface PricingEntry {
  sku: string;
  eur: number;
  /** Display "from €X" rather than a flat price. */
  fromPrefix?: boolean;
}

export const PRICING_CATALOG = {
  free:         { sku: "tier-free",             eur: 0    },
  founderM:     { sku: "founder-pass-monthly",  eur: eurMajor(PRICING.founder_pass.monthly_eur_cents) },
  founderY:     { sku: "founder-pass-annual",   eur: eurMajor(PRICING.founder_pass.annual_eur_cents)  },
  bootcampB:    { sku: "bootcamp-beginner",     eur: eurMajor(PRICING.bootcamp.beginner_eur_cents)     },
  bootcampI:    { sku: "bootcamp-intermediate", eur: eurMajor(PRICING.bootcamp.intermediate_eur_cents) },
  bootcampA:    { sku: "bootcamp-advanced",     eur: eurMajor(PRICING.bootcamp.advanced_eur_cents)     },
  coach4:       { sku: "coaching-4h",           eur: eurMajor(PRICING.coaching.tier_4h_eur_cents)  },
  coach8:       { sku: "coaching-8h",           eur: eurMajor(PRICING.coaching.tier_8h_eur_cents)  },
  coach12:      { sku: "coaching-12h",          eur: eurMajor(PRICING.coaching.tier_12h_eur_cents) },
  fractional:   { sku: "fractional-exec",       eur: eurMajor(PRICING.fractional.from_eur_cents),   fromPrefix: true },
  microservice: { sku: "microservice-base",     eur: eurMajor(PRICING.microservice.from_eur_cents), fromPrefix: true },
  teamsSeat:    { sku: "teams-seat-monthly",    eur: eurMajor(PRICING.team.seat_monthly_eur_cents) },
} satisfies Record<string, PricingEntry>;

export type PricingKey = keyof typeof PRICING_CATALOG;